import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from '@/App'
import { AuthProvider } from '@/auth/AuthProvider'
import { ToastProvider } from '@/components/ui/ToastProvider'
import { initMonitoring } from '@/lib/monitoring'
import '@/index.css'

// Мониторинг поднимаем в фоне и никогда его не ждём: во Flutter-версии
// Sentry стоял перед стартом приложения и подвешивал админку вечным
// спиннером. Здесь падение init не мешает UI.
void initMonitoring()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
)
